var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full mb-big-title"},[_c('vx-card',{staticClass:"big-title-card"},[_c('h1',{staticClass:"rg-big-title extrabold"},[_vm._t("default")],2)])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }